import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrgBrandingService } from '@app/orgs/services/org-branding.service';
import { CropperCoordinates } from '@app/uploader/image-cropper-modal/image-cropper-modal.model';
import { ImageCropperService } from '@app/uploader/image-cropper-modal/services/image-cropper.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'dgx-logo-uploader',
    templateUrl: './logo-uploader.component.html',
    styleUrls: ['./logo-uploader.component.scss'],
    standalone: false
})
export class LogoUploaderComponent {
  @Input() public brandingData;
  @Input() public changeText: string;
  @Input() public cropperTitle: string;
  @Input() public orgId: number;
  @Output() public onImageChange = new EventEmitter<any>();

  public croppedDisplayImage;
  public cropperCoordinates;
  public selectedFile: File;
  public src: string;
  public uploaderFocused: boolean;

  constructor(
    private imageCropperService: ImageCropperService,
    private orgBrandingService: OrgBrandingService,
    private translate: TranslateService
  ) {}

  public onImageSelected(event) {
    const files = event.target ? event.target.files : event;
    const file = files.item(0);
    if (!file) {
      return;
    }

    this.selectedFile = file;
    this.setImagePreview(this.selectedFile).subscribe((imageUrl) => {
      this.src = imageUrl;
      this.openCropper(this.src);
    });
  }

  public setImagePreview(file: File): Observable<string> {
    return new Observable((observer) => {
      const reader = new FileReader();
      reader.onload = () => {
        observer.next(reader.result as string);
        observer.complete();
      };
      reader.readAsDataURL(file);
    });
  }

  public openCropper(
    imageUrl: string,
    cropperCoordinates?: CropperCoordinates
  ) {
    let cropperCanceled = true;

    // TODO: get the magic numbers out of the settings
    const modalInstructions = this.translate.instant(
      'dgImageEdit_ImageDimensionsFormat',
      {
        resolutionWidth: '200',
        resolutionHeight: '200',
      }
    );

    this.imageCropperService
      .showCropperModal({
        imageUrl,
        cropperCoordinates,
        aspectRatio: 1,
        modalTitle: this.cropperTitle,
        modalInstructions,
        maintainAspectRatio: false,
        hideAltTextInput: true,
      })
      .subscribe({
        next: (data) => {
          if (data) {
            this.croppedDisplayImage = data.base64;
            this.cropperCoordinates = data.cropperCoordinates;
            cropperCanceled = false;
            this.saveImage(this.selectedFile, data.cropperCoordinates);
          }
        },
      });
  }

  public saveImage(file, coordinates) {
    // Delete old image
    this.orgBrandingService
      .discardBrandingImage(this.orgId, this.brandingData.orgImage)
      .subscribe();
    // Add new one
    this.orgBrandingService
      .uploadLogoFile(file, coordinates, this.orgId)
      .subscribe((response) => {
        this.brandingData.orgImage = response?.pictureUrl;
        this.brandingData.srcSet = this.orgBrandingService.getOrgImageSrcSet(
          response?.pictureUrl
        );

        this.onImageChange.emit(response);
      });
  }

  public onBlur() {
    this.uploaderFocused = false;
  }

  public onFocus() {
    this.uploaderFocused = true;
  }

  public onChangeDragState(event) {
    switch (event) {
      case 'dragover':
        this.uploaderFocused = true;
        break;
      default:
        this.uploaderFocused = false;
    }
  }
}
